import {IPropertyListProperty} from "../../../property/types/PropertyListProperty";
import {Country} from "../../../region/types/Country";
import {getCountryName} from "../../../region/utils/get_country_name";
import {GTMEcommerceItem, GTMEcommerceVariantItem} from "../../../tracking/google_tag_manager/common_interfaces/GTMEcommerceItem";
import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/init_google_tag_manager";
import {OfferType} from "../../types/OfferType";
import {gtmEcommerceOfferTypeMap} from "./gtm_offer_list_tracking";

interface HitPropertyListViewParams {
    offer: {
        id: number;
        name: string;
        type: OfferType;
        region: {
            country: Country;
        };
        vendor: {
            name: string;
        };
    };
    properties: IPropertyListProperty[];
    region: {
        voivodeship: string;
        city: string | null;
        town: string | null;
        district: string | null;
    };
    listingName: string;
}

export const hitEcommercePropertiesListView = (params: HitPropertyListViewParams) => {
    const properties: GTMEcommerceVariantItem[] = params.properties.map((property, index) => {
        return {
            variant_id: property.id.toString(),
            variant_name: property.number,
            variant_rooms: property.rooms.toString(),
            variant_status: property.is_reserved ? "reserved" : "available",
            variant_list_name: params.listingName,
            variant_index: index
        };
    });

    const offerData: GTMEcommerceItem = {
        item_id: params.offer.id.toString(),
        item_name: params.offer.name,
        price: 1,
        item_brand: params.offer.vendor.name,
        item_category: getCountryName(params.offer.region.country, "pl") || "na",
        item_category2: params.region.voivodeship || "na",
        item_category3: params.region.city || "na",
        item_category4: params.region.district || "na",
        item_category5: gtmEcommerceOfferTypeMap[params.offer.type as OfferType],
        variant: properties
    };

    hitGoogleTagManager({
        event: "view_item_list",
        item_list_name: params.listingName,
        ecommerce: {
            items: [offerData]
        }
    });
};
import {IPropertyListProperty} from "../../../property/types/PropertyListProperty";
import {Country} from "../../../region/types/Country";
import {getCountryName} from "../../../region/utils/get_country_name";
import {GTMEcommerceItem, GTMEcommerceVariantItem} from "../../../tracking/google_tag_manager/common_interfaces/GTMEcommerceItem";
import {hitGoogleTagManager} from "../../../tracking/google_tag_manager/init_google_tag_manager";
import {OfferType} from "../../types/OfferType";
import {gtmEcommerceOfferTypeMap} from "./gtm_offer_list_tracking";

interface HitPropertyListViewParams {
    offer: {
        id: number;
        name: string;
        type: OfferType;
        region: {
            country: Country;
        };
        vendor: {
            name: string;
        };
    };
    properties: IPropertyListProperty[];
    region: {
        voivodeship: string;
        city: string | null;
        town: string | null;
        district: string | null;
    };
    listingName: string;
}

export const hitEcommercePropertiesListView = (params: HitPropertyListViewParams) => {
    const properties: GTMEcommerceVariantItem[] = params.properties.map((property, index) => {
        return {
            variant_id: property.id.toString(),
            variant_name: property.number,
            variant_rooms: property.rooms.toString(),
            variant_status: property.is_reserved ? "reserved" : "available",
            variant_list_name: params.listingName,
            variant_index: index
        };
    });

    const offerData: GTMEcommerceItem = {
        item_id: params.offer.id.toString(),
        item_name: params.offer.name,
        price: 1,
        item_brand: params.offer.vendor.name,
        item_category: getCountryName(params.offer.region.country, "pl") || "na",
        item_category2: params.region.voivodeship || "na",
        item_category3: params.region.city || "na",
        item_category4: params.region.district || "na",
        item_category5: gtmEcommerceOfferTypeMap[params.offer.type as OfferType],
        variant: properties
    };

    hitGoogleTagManager({
        event: "view_item_list",
        item_list_name: params.listingName,
        ecommerce: {
            items: [offerData]
        }
    });
};
